// PHASE 4: What limiting beliefs hold you back?
import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🧒',
    title: 'pages.onboarding.learningBlocks.answer1',
  },
  {
    emoji: '🧠',
    title: 'pages.onboarding.learningBlocks.answer2',
  },
  {
    emoji: '⏳',
    title: 'pages.onboarding.learningBlocks.answer3',
  },
  {
    emoji: '😰',
    title: 'pages.onboarding.learningBlocks.answer4',
  },
  {
    emoji: '📚',
    title: 'pages.onboarding.learningBlocks.answer5',
  },
  {
    emoji: '💪',
    title: 'pages.onboarding.learningBlocks.answer6',
  },
]

export default function LearningBlocksPage() {
  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.learningBlocks.title"
      subtitle="pages.onboarding.learningBlocks.subtitle"
    />
  )
}
